import { render } from "./Tinglovchilar.vue?vue&type=template&id=5acc85a2"
import script from "./Tinglovchilar.vue?vue&type=script&lang=js"
export * from "./Tinglovchilar.vue?vue&type=script&lang=js"

import "./Tinglovchilar.vue?vue&type=style&index=0&id=5acc85a2&lang=css"

import exportComponent from "D:\\xurshid\\PROJECTS\\fvvga\\sayt\\vue_asosiy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__